import React, {useContext} from 'react';
import './PermissionRequest.less';
import {NavigationItem} from '../navigation-item/NavigationItem';
import {IconBadgeColors} from 'elements/icon-badge/IconBadge';
import {Card, CardStyles} from 'elements/card/Card.tsx';
import {TranslationsContext} from '../../../contexts/translations-context';

export const PermissionRequest = ({icon, text, onClick}) => {
	const translations = useContext(TranslationsContext);

	return (<div className="permission-request" onClick={onClick}>
		<Card style={CardStyles.PRIMARY}>
			<NavigationItem
				icon={icon}
				name={text}
				iconColor={IconBadgeColors.primary}
				isPrimary
			/>
		</Card>
	</div>);
};
